module.exports = __webpack_public_path__ + "static/media/littleband_logo.6c007865.png";